import { ReferClientAction } from './actions';

import {
  REFER_CLIENT_REQUEST_START,
  REFER_CLIENT_REQUEST_FAIL,
  REFER_CLIENT_REQUEST_SUCCESS,
  ETV_OPTION_REQUEST_START,
  ETV_OPTION_REQUEST_FAIL,
  ETV_OPTION_REQUEST_SUCCESS,
  REFER_AFFILIATE_REQUEST_START,
  REFER_AFFILIATE_REQUEST_SUCCESS,
  REFER_AFFILIATE_REQUEST_FAIL
} from './types';

export type EtvOptions = {
  options: {
    label: string,
    value: string
  }[]
}

type ReferClientState = {
  loadingState: string,
  etvOptions: EtvOptions
};

const INITIAL_STATE: ReferClientState = {
  loadingState: 'UNINITIALISED',
  etvOptions: {
    options: [{
      label: '',
      value: ''
    }]
  }
};

export const reducer = (
  state = INITIAL_STATE,
  action: ReferClientAction
): ReferClientState => {
  switch (action.type) {
    case REFER_CLIENT_REQUEST_START:
      return {
        ...state,
        loadingState: 'LOADING'
      };

    case REFER_CLIENT_REQUEST_SUCCESS:
      return {
        ...state,
        loadingState: 'LOADED'
      };

    case REFER_CLIENT_REQUEST_FAIL:
      return {
        ...state,
        loadingState: 'ERROR'
      };

    case REFER_AFFILIATE_REQUEST_START:
      return {
        ...state,
        loadingState: 'LOADING'
      };

    case REFER_AFFILIATE_REQUEST_SUCCESS:
      return {
        ...state,
        loadingState: 'LOADED'
      };

    case REFER_AFFILIATE_REQUEST_FAIL:
      return {
        ...state,
        loadingState: 'ERROR'
      };

    case ETV_OPTION_REQUEST_START:
      return {
        ...state,
        loadingState: 'LOADING'
      };

    case ETV_OPTION_REQUEST_SUCCESS:
      return {
        ...state,
        loadingState: 'LOADED',
        etvOptions: action.payload
      };

    case ETV_OPTION_REQUEST_FAIL:
      return {
        ...state,
        loadingState: 'ERROR'
      };
    default:
      return state;
  }
};